module.exports = __webpack_public_path__ + "static/media/air-tools.d7a84b75.jpg";